import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import language from 'utils/vast-languagepack'
import {
	FormControl,
	InputLabel,
	OutlinedInput,
	withStyles,
	FormHelperText,
} from '@material-ui/core'
import { handleTemplateNameChange } from 'actions/template'
import styles from './styles'

export default connect(
	(state) => {
		const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
		const disabled = Boolean(
			(stats && automationTypeSelected !== 'stage') ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return { value: state.email.templateName.value, disabled }
	},
	(dispatch) => bindActionCreators({ handleTemplateNameChange }, dispatch),
)(
	withStyles(styles)(
		class TemplateName extends Component {
			componentDidMount() {
				this.forceUpdate()
			}

			render() {
				return (
					<FormControl
						disabled={this.props.disabled}
						fullWidth
						variant="outlined"
					>
						<InputLabel
							ref={(ref) => {
								this.labelRef = ReactDOM.findDOMNode(ref)
							}}
							htmlFor={`formTextField${'Description'}`}
							shrink
							style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
						>
							{`${language.task.add.labels.templateName} (required)`}
						</InputLabel>
						<OutlinedInput
							labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
							value={this.props.value}
							onChange={(e) =>
								this.props.handleTemplateNameChange(e.target.value)
							}
							notched
							classes={{
								notchedOutline: this.props.warning
									? this.props.classes.notchedOutlineWarning
									: this.props.classes.notchedOutline,
							}}
						/>
						<FormHelperText>{this.props.helperText}</FormHelperText>
					</FormControl>
				)
			}
		},
	),
)
